import { ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, StackJustifyContent, StackType, StackWidth, WIDGET } from "@voltmoney/schema";
import { convertISODate } from "../partnerWeb_Dashboard/utils";
export const partnerDetailsDSBuilder = (FieldsObject) => {
    let DATA_STORE = {};
    const WIDGET_STORE = [];
    Object.keys(FieldsObject).forEach((key, index) => {
        WIDGET_STORE.push({ id: `partnerViewDetailsLeadsBodyS${index}`, type: WIDGET.STACK }, { id: `partnerViewDetailsLeadsBodyDivider${index}`, type: WIDGET.DIVIDER });
        DATA_STORE = {
            ...DATA_STORE,
            [`partnerViewDetailsLeadsBodyS${index}`]: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                justifyContent: StackJustifyContent.spaceBetween,
                padding: {
                    top: SizeTypeTokens.XL,
                    bottom: SizeTypeTokens.XL
                },
                widgetItems: [
                    { id: `partnerViewDetailsLeadsBodyS${index}T1`, type: WIDGET.TEXT },
                    { id: `partnerViewDetailsLeadsBodyS${index}T2`, type: WIDGET.TEXT }
                ]
            },
            [`partnerViewDetailsLeadsBodyS${index}T1`]: {
                label: `${key}`,
                fontWeight: '400',
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Night,
                lineHeight: 20,
            },
            [`partnerViewDetailsLeadsBodyS${index}T2`]: {
                label: `${FieldsObject[key]}`,
                fontWeight: '400',
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Night,
                lineHeight: 20,
            },
            [`partnerViewDetailsLeadsBodyDivider${index}`]: {
                color: ColorTokens.Grey_Chalk,
                size: DividerSizeTokens.MD
            },
        };
    });
    return { DATA_STORE, WIDGET_STORE };
};
export const returnDateInString = (epochDate) => {
    const { date, month, year } = convertISODate(epochDate);
    return `${date} ${month.slice(0, 3)}, ${year}`;
};
